// extracted by mini-css-extract-plugin
export default {"priorityDiv":"ListItems_priorityDiv__P+4gV"};